var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container css-2022-2-11-09-54-35" },
    [
      _c("div", { staticClass: "page-buttons" }, [
        _c(
          "div",
          { staticClass: "page-buttons-left" },
          [
            _c(
              "el-button",
              {
                staticClass: "main-btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新增菜单")]
            ),
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-refresh", size: "mini" },
                on: { click: _vm.reFresh },
              },
              [_vm._v(_vm._s(_vm.$t("refreshText")))]
            ),
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-delete", size: "mini" },
                on: { click: _vm.batchDelete },
              },
              [_vm._v("批量删除")]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "danger",
                  icon: "el-icon-magic-stick",
                  size: "mini",
                },
                on: { click: _vm.init },
              },
              [_vm._v("初始化")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "page-buttons-right" }),
      ]),
      _c(
        "div",
        { staticClass: "el-tree-1" },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.tableData,
              "show-checkbox": "",
              "node-key": "id",
              "highlight-current": "",
              props: {
                children: "children",
                label: "title",
              },
              "expand-on-click-node": false,
              "default-expanded-keys": _vm.defaultExpandedkeys,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var node = ref.node
                  var data = ref.data
                  return _c("div", { staticClass: "custom-tree-node" }, [
                    _c(
                      "span",
                      [
                        _c(
                          "el-tag",
                          {
                            staticClass: "el-tag-left",
                            attrs: {
                              type: _vm.SETTING_PERMISSION_TYPE_COLOR_LIST.bjGet(
                                data.permissionType
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.SETTING_PERMISSION_TYPE_LIST.bjGet(
                                    data.permissionType
                                  )
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(_vm._s(node.label)),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "span-btn" },
                      [
                        data.name != "菜单"
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { color: "red" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function () {
                                    return _vm.remove(node, data)
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(node, data)
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "20px" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function () {
                                return _vm.onAdd(data)
                              },
                            },
                          },
                          [_vm._v(" 添加子菜单 ")]
                        ),
                      ],
                      1
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("DataForm", {
        ref: "DataForm",
        attrs: { "a-p-i": _vm.API },
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }